import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Alert, AlertTitle, Box, Card, CardContent, CircularProgress } from "@mui/material";

import { decryptAesZeroPadding } from "../utils/crypto";
import { GetProfile } from "../redux/actions/profileActions";
import { GetAddress, GetCompanyAction } from "../redux/actions/companyAction";
import { useDispatch, useSelector } from "react-redux";
import outWardService from "../services/outWardService";
import useAlert from "../hooks/useAlert";

export const PaymentPage = () => {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [paymentLoading, setPaymentLoading] = useState(false);
    const [user, setUser] = useState(null);
    const [company, setCompany] = useState(null);
    const [adres, setAdres] = useState(null);
    const [paymentResponse, setPaymentResponse] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const dispatch = useDispatch();
    const encryptedBase64 = location.pathname.replace("/payment/", "");
    const { showSuccessAlertPayment } = useAlert();
    let decryptedText = "";
    try {
        decryptedText = decryptAesZeroPadding(encryptedBase64);
    } catch (error) {
        console.error("Decrypt sırasında hata oluştu:", error);
        decryptedText = "(Çözülemedi)";
    }

    const authUserId = useSelector((state) => state?.auth?.user?.id);
    const token = useSelector((state) => state?.auth?.user?.accessToken?.token);

    useEffect(() => {
        const getProfileDetail = async () => {
            try {
                setLoading(true);
                const response = await dispatch(GetProfile(authUserId, token));
                setUser(response);
                getCompany();
            } catch (error) {
                setLoading(false);
                console.error("Error fetching profile:", error);
            }
        };

        const getCompany = async () => {
            try {
                const id = authUserId;
                const response = await dispatch(GetCompanyAction(id, token));
                setCompany(response?.data[0]);
                getAddress(response.data[0]?.id);
                return response;
            } catch (error) {
                setLoading(false);
                console.error("Error fetching store:", error);
            }
        };

        const getAddress = async (companyId) => {
            try {
                const response = await dispatch(GetAddress(companyId, token));
                setAdres(response?.data[0]);
                setLoading(false);
                return response;
            } catch (error) {
                setLoading(false);
                console.error("Error fetching profile:", error);
            }
        };

        getProfileDetail();
    }, []);

    useEffect(() => {
        const payment = async () => {
            try {
                setPaymentLoading(true);
                const parsedData = JSON.parse(decryptedText);
                const requestModel = {
                    user: user,
                    company: company,
                    companyAddresses: adres,
                    Price: parsedData?.Ucret || null,
                    PackageName: parsedData?.Baslik || null,
                    PackageId: parsedData?.ID ? parsedData.ID.toString() : null,
                };
                const result = await outWardService.payment(requestModel);
                setPaymentResponse(result?.data);


            } catch (error) {
                setPaymentLoading(false);
                console.error("Error in payment process:", error);
            }
        };

        if (company && user && adres && !paymentLoading) {
            payment();
        }
    }, [adres]);

    useEffect(() => {
        if (paymentResponse?.content) {
            try {
                const parser = new DOMParser();
                const doc = parser.parseFromString(paymentResponse.content, "text/html");
                const script = doc.querySelector("script");

                if (script) {
                    const newScript = document.createElement("script");
                    newScript.textContent = script.textContent;
                    document.body.appendChild(newScript);
                    if (script.getAttribute("src")) {
                        const externalScript = document.createElement("script");
                        externalScript.src = script.getAttribute("src");
                        externalScript.async = true;
                        document.body.appendChild(externalScript);
                    }
                }
            } catch (error) {
                console.error("Error appending script:", error);
            } finally {
                setLoading(false);
            }
        }
    }, [paymentResponse]);

    useEffect(() => {
        let intervalId;

        const fetchPaymentStatus = async () => {
            try {
                setLoading(true);
                const status = await outWardService.paymentStatus("Iyzico", paymentResponse?.paymentId);
                setPaymentStatus(status);
                if (status?.success) {
                    clearInterval(intervalId);
                    console.log("Ödeme tamamlandı, istek döngüsü durduruldu.");
                }
            } catch (error) {
                console.error("Error fetching payment status:", error);
            } finally {
                setLoading(false);
            }
        };

        if (paymentResponse?.paymentId&&paymentStatus?.status!=true) {
            intervalId = setInterval(fetchPaymentStatus, 5000); 
        }else if(paymentStatus?.status==true){
            showSuccessAlertPayment();
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId); 
            }
        };
    }, [paymentResponse]);

    return (
        <Box sx={{ mt: 5 }}>
            <h1>Ödeme Sayfası</h1>
            {(company==null||adres==null)&&loading!=true&&
      <Alert sx={{mb:5}} variant="outlined" severity="error">
    Profil bilgilerinizi kontrol ediniz adres ve şirket alanları eksiksiz olmalıdır
    </Alert>
            }
            {loading ? <CircularProgress /> : <div dangerouslySetInnerHTML={{ __html: paymentResponse?.content }} />}
        </Box>
    );
};

export default PaymentPage;
